import React from 'react';
import { MapPin, Calendar, GraduationCap, Target, Eye, Heart } from 'lucide-react';

const OurHistory = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-green-800 mb-4">
            Welcome to Ever Green Senior Secondary School
          </h1>
          <div className="w-24 h-1 bg-green-600 mx-auto rounded-full"></div>
        </div>

        {/* Introduction Card */}
        <div className="bg-white rounded-xl shadow-lg p-8 mb-8 border-l-4 border-green-600">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <GraduationCap className="w-8 h-8 text-green-600 mt-1" />
            </div>
            <div>
              <p className="text-gray-700 leading-relaxed text-lg">
                Ever Green Senior Secondary School established on <span className="font-semibold text-green-700">13th July 1996</span> by 
                <span className="font-semibold text-green-700"> Mr. L. D. Pathak</span> in Haldwani city of Uttarakhand in India, 
                is a premier English Medium educational institution affiliated to C.B.S.E., New Delhi which is owned by a registered 
                organisation "EDUCATIONAL WELFARE SOCIETY", Tularampur.
              </p>
            </div>
          </div>
        </div>

        {/* Location Section */}
        <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
          <div className="flex items-center space-x-3 mb-6">
            <MapPin className="w-6 h-6 text-green-600" />
            <h2 className="text-2xl font-bold text-gray-800">Location & Connectivity</h2>
          </div>
          <div className="space-y-4">
            <div className="bg-green-50 p-4 rounded-lg">
              <h3 className="font-semibold text-green-800 mb-2">Address</h3>
              <p className="text-gray-700">
                Sri Ganga Vihar Colony, Beriparao, Vill- Tularampur, P.O.- Motahaldu, 
                Teh- Lalkuan, Nainital, Uttrakhand on Bareilly Nainital Highway (NH- 109)
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="font-semibold text-blue-800 mb-2">Landmark</h4>
                <p className="text-gray-700">ASTHADASH BHUJA MAHALAKSHMI TEMPLE (0.5 km)</p>
              </div>
              <div className="bg-yellow-50 p-4 rounded-lg">
                <h4 className="font-semibold text-yellow-800 mb-2">Bus Station</h4>
                <p className="text-gray-700">Haldwani (10 km)</p>
              </div>
              <div className="bg-purple-50 p-4 rounded-lg">
                <h4 className="font-semibold text-purple-800 mb-2">Railway Station</h4>
                <p className="text-gray-700">LALKUAN (5 km)</p>
              </div>
              <div className="bg-red-50 p-4 rounded-lg">
                <h4 className="font-semibold text-red-800 mb-2">Airport</h4>
                <p className="text-gray-700">PANTNAGAR (12 km)</p>
              </div>
            </div>
          </div>
        </div>

        {/* History Section */}
        <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
          <div className="flex items-center space-x-3 mb-6">
            <Calendar className="w-6 h-6 text-green-600" />
            <h2 className="text-2xl font-bold text-gray-800">Our History</h2>
          </div>
          <div className="space-y-6">
            <p className="text-gray-700 leading-relaxed">
              History of Ever Green Senior Secondary School is really a moral and courage boosting for all new school starters, 
              as it is the first English Medium School ever started in location of remote rural area.
            </p>
            
            <div className="bg-gradient-to-r from-green-100 to-blue-100 p-6 rounded-lg">
              <h3 className="font-bold text-green-800 mb-3">Founder's Vision</h3>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Mr. LUXMI DUTT PATHAK</span>, the one who drove pleasure and took step in this direction, 
                was a farmer. He utilized his bright academics and enthusiasm in this direction. He has PG degree in Economics & Political Science.
              </p>
            </div>

            <div className="space-y-4">
              <h3 className="font-bold text-gray-800">Milestones</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-4 p-3 bg-green-50 rounded-lg">
                  <div className="w-3 h-3 bg-green-600 rounded-full"></div>
                  <div>
                    <span className="font-semibold text-green-700">2002:</span> 
                    <span className="text-gray-700 ml-2">Primary affiliation through District Education Officer</span>
                  </div>
                </div>
                <div className="flex items-center space-x-4 p-3 bg-blue-50 rounded-lg">
                  <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
                  <div>
                    <span className="font-semibold text-blue-700">2005:</span> 
                    <span className="text-gray-700 ml-2">Jr. High School affiliation from Anglo Indian Board of Uttrakhand</span>
                  </div>
                </div>
                <div className="flex items-center space-x-4 p-3 bg-purple-50 rounded-lg">
                  <div className="w-3 h-3 bg-purple-600 rounded-full"></div>
                  <div>
                    <span className="font-semibold text-purple-700">2011:</span> 
                    <span className="text-gray-700 ml-2">Upgraded with C.B.S.E. affiliation, running up to class XII</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-500">
              <p className="text-gray-700 font-medium">
                Today it is known fact that EVER GREEN is truly the best in Scholastic and in over all personality development 
                and becomes the best learning centre for the children.
              </p>
            </div>
          </div>
        </div>

        {/* Motto Section */}
        <div className="bg-gradient-to-r from-green-600 to-blue-600 text-white rounded-xl shadow-lg p-8 mb-8">
          <div className="text-center">
            <Heart className="w-8 h-8 mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-4">The Motto of the School</h2>
            <div className="text-3xl font-bold mb-4 text-yellow-300">विधैव बलम</div>
            <p className="text-lg leading-relaxed">
              To educate children by bringing them together and giving full scope to them for their work of intellectual 
              exploration and creativity. This will inculcate in the students a strong foundation of academic excellence 
              and creativity which will enhance their personality to find a respectable place in future society.
            </p>
          </div>
        </div>

        {/* Mission and Vision */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Mission */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center space-x-3 mb-6">
              <Target className="w-6 h-6 text-green-600" />
              <h2 className="text-2xl font-bold text-gray-800">Our Mission</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              To emerge as a role model in holistic, value based and exploratory learning campus in the society. 
              We aspire to create an educational environment which produces self motivated learners and responsible future citizens.
            </p>
          </div>

          {/* Vision */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center space-x-3 mb-6">
              <Eye className="w-6 h-6 text-blue-600" />
              <h2 className="text-2xl font-bold text-gray-800">Our Vision</h2>
            </div>
            <p className="text-gray-700 leading-relaxed">
              To create leaders of tomorrow with intuitive capabilities and an appreciation for learning as the core value of success. 
              We are Nurturing the leaders of tomorrow. Our school is to go beyond conventional education and develop students into 
              well rounded individuals, inculcate in them values of integrity and ability to distinguish the appropriate and inappropriate. 
              All of this we aim to provide in a conducive, creative and secure environment.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-12 p-6 bg-green-800 text-white rounded-xl">
          <p className="text-lg font-medium">
            Ever Green Senior Secondary School - Nurturing Excellence Since 1996
          </p>
        </div>
      </div>
    </div>
  );
};

export default OurHistory;